import { useEffect, useState } from "react";
import { X, Download, Smartphone } from "lucide-react";

const DISMISS_KEY = "bravura_drive_install_dismissed_at";
const DISMISS_DAYS = 7;

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed) {
      const ageDays = (Date.now() - parseInt(dismissed, 10)) / (1000 * 60 * 60 * 24);
      if (ageDays < DISMISS_DAYS) return;
    }
    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    // already installed?
    window.addEventListener("appinstalled", () => setVisible(false));
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const choice = await deferred.userChoice;
    if (choice.outcome === "accepted") {
      setVisible(false);
    }
    setDeferred(null);
  };

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, String(Date.now()));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="install-prompt"
      className="fixed bottom-20 left-3 right-3 z-40 rounded-2xl bg-bravura text-white p-4 shadow-2xl ring-2 ring-white/20"
    >
      <button
        onClick={dismiss}
        data-testid="install-prompt-dismiss"
        className="absolute top-2 right-2 h-7 w-7 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center"
      >
        <X className="h-4 w-4" />
      </button>
      <div className="flex items-start gap-3">
        <div className="h-11 w-11 rounded-xl bg-white/15 flex items-center justify-center flex-shrink-0">
          <Smartphone className="h-5 w-5" />
        </div>
        <div className="flex-1 pr-6">
          <div className="text-sm font-bold">Install Bravura Trucking</div>
          <div className="text-[11px] text-bravura-100 mt-0.5">
            Phone ke home-screen pe save kar lo — offline bhi chalega
          </div>
        </div>
      </div>
      <button
        onClick={install}
        data-testid="install-prompt-install"
        className="mt-3 w-full rounded-xl bg-white text-bravura-700 py-2.5 font-bold flex items-center justify-center gap-2 active:scale-[0.99]"
      >
        <Download className="h-4 w-4" /> Install App
      </button>
    </div>
  );
}
